import { Dayjs } from 'dayjs'
import { Attachment } from '../bankaccount/bankaccount-typed'
import { Address } from '../port/port-typed'

export type RiskAssessment = {
  answer: true
  createdAt: string
  deletedAt: string | null | undefined
  description: string
  id: string
  kycId: string
  questionCode: string
  updatedAt: string
}

export type Kyc = {
  birthdate: string
  callbackConvenientTime: CallbackConvenientTime[] | null
  attachments: Attachment[]
  callbackMobileNo: string
  citizenId: string
  createdAt: string
  deletedAt: string
  ekycStatus: string
  ekycStatusAt: string
  ekycUserId: string
  email: string
  firstnameEn: string
  firstnameTh: string
  gender: string
  id: string
  idempotencyKey: string
  job: string
  laserCode: string
  lastnameEn: string
  lastnameTh: string
  mobileNo: string
  refCode: string
  registerError?: string
  rejectReason?: string
  tinNo: string
  titleEn: string
  titleTh: string
  updatedAt: string
  userId: string
  dopa: {
    isError: 'true' | 'false'
    errorMessage: any[]
    code: string
    desc: string
  }
  amlo: {
    status: 'not pass' | 'pass'
    data: string
  }
  addresses?: Address[]
  riskAssessments: RiskAssessment[]
  rejectedBy?: EnumKycRejectedBy
  isApproveMinimum: boolean
  logs: Log[]
}

export enum EnumKycRejectedBy {
  REJECT_BY_ADMIN = 'reject_by_admin',
  REJECT_BY_EAGLE = 'reject_by_eagle',
  REJECT_BY_PORT_DIFF = 'reject_by_port_diff',
}

export enum EnumKycRejectedType {
  OVER_SOLD = 'over_sell',
  SAFE_GOLD_CONDITION = 'safe_gold_condition',
}

export type IFreezeAccountBody = {
  type: EnumKycRejectedType
  rejectReason?: string
}

export type CallbackConvenientTime = {
  contactEnd: string
  contactStart: string
}

export type Log = {
  data: any
  createdAt: string
}

export type PageMeta = {
  currentPage: number
  itemCount: number
  itemsPerPage: number
  totalItems: number
  totalPages: number
}
export type KycList = {
  items: Kyc[]
  meta: PageMeta
}

export type ExportKycReportParams = {
  startDate: Dayjs
  endDate: Dayjs
  status?: EKycProfileStatus
}

export enum EKycState {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  REJECT_BY_ADMIN = 'reject_by_admin',
  REJECT_BY_EAGLE = 'reject_by_eagle',
  REJECT_BY_PORT_DIFF = 'reject_by_port_diff',
}

export enum EKycProfileStatus {
  FULL_PROFILE = 'full_profile',
  LEVEL_0 = 'level_0',
  NO_PROFILE = 'no_profile',
  HIGH_RISK = 'high_risk',
  REJECT_BY_ADMIN = 'reject_by_admin',
  REJECT_BY_EAGLE = 'reject_by_eagle',
  REJECT_BY_PORT_DIFF = 'reject_by_port_diff',
}
